import { supabase } from "../../../supabaseClient";

export async function fetchEventIdsForTournament(tournamentId) {
  const { data, error } = await supabase
    .from("tournamentEvents")
    .select("id")
    .eq("tournamentID", tournamentId)
    .eq("isDeleted", false);

  if (error) {
    console.error("❌ ERROR: fetchEventIdsForTournament failed:", error);
    throw error;
  }
  return data.map((event) => event.id);
}
